import React from "react";
import SelectFieldR from "../components/SelectFieldR.js";
import SelectField from "../components/SelectField.js";
import TextField from "../components/TextField.js";
import ToggleField from "../components/ToggleField.js";
import MultiToggleField from "../components/MultiToggleField.js";
import TextFieldSt from "../components/TextfieldSt.js";
import TextFieldPerncentage from "../components/TextFieldPerncentage.js";
import MapComponent from "../components/MapComponent.js";
import TextfieldStHide from "../components/TextfieldStHide.js";
import TextFieldStP from "../components/TextfieldStP.js";
import TextFieldStSame from "../components/TextFieldStSame.js";
import TextFieldStSameP from "../components/TextFieldStSameP.js";
import Images from "../components/Images.js";
import TextFieldR from "../components/TextFieldR.js";
import SitePotential from "../components/SitePotentialV";
import ConstructionCost from "../components/ConstructionCostV.js";
import LandAnalysis from "../components/LandAnalysisV.js";
import SaleCosts from "../components/SaleCostsV.js";
import PerformaBreakdown from "../components/PerformaBreakdownV.js";
import PerformaReport from "../components/PerformaReport.js";
import Financing from "../components/FinancingV.js";
const Components = {
  1: SelectField,
  2: TextField,
  3: ToggleField,
  4: MultiToggleField,
  5: TextFieldSt,
  6: TextFieldPerncentage,
  7: MapComponent,
  8: TextfieldStHide,
  9: TextFieldStP,
  10: TextFieldStSame,
  11: Images,
  12: TextFieldStSameP,
  13: TextFieldR,
  14: SelectFieldR,
  15: SitePotential,
  16: ConstructionCost,
  17: LandAnalysis,
  18: SaleCosts,
  19: PerformaBreakdown,
  20: Financing,
  21: PerformaReport,
};

export default (item, data, setData, useVals, IsSite, object) => {
  if (typeof Components[item.ParameterTypeId] !== "undefined") {
    if (item.Phase === "Site Potential") {
      if (IsSite == 0) {

        if (item.ParameterId == 85 || item.ParameterId == 86 || item.ParameterId == 217 || item.ParameterId == 31 || item.ParameterId == 284 || item.ParameterId == 285 || item.ParameterId == 286
          || item.ParameterId == 184 || item.ParameterId == 185 || item.ParameterId == 188 || item.ParameterId == 30
          || item.ParameterId == 32 || item.ParameterId == 34 || item.ParameterId == 96 || item.ParameterId == 79
          || item.ParameterId == 71 || item.ParameterId == 80 || item.ParameterId == 216 || item.ParameterId == 215
          || item.ParameterId == 67 || item.ParameterId == 33 || item.ParameterId == 35 || item.ParameterId == 40
          || item.ParameterId == 48 || item.ParameterId == 49 || item.ParameterId == 68 || item.ParameterId == 70
          || item.ParameterId == 129 || item.ParameterId == 199) {
          return React.createElement(Components[15], {
            id: item.ParameterId,
            name: item.ParameterName,
            IsManual: item.IsManual,
            setData: setData,
            data: data,
            value: useVals ? item.value : null,
            structureType: item.structureType || null,
            key: (item.structureType || " sds ") + item.ParameterId,
            wholeEl: item,
            ischecked: item.ischecked
          });
        }
        else {
          return React.createElement(
            () => <div></div>,
            { key: item._uid }
          );
        }
      }
      if (IsSite == 1) {
        if (item.ParameterId == 249 || item.ParameterId == 37 || item.ParameterId == 250
          || item.ParameterId == 251 || item.ParameterId == 38 || item.ParameterId == 252
          || item.ParameterId == 253 || item.ParameterId == 39 || item.ParameterId == 254
          || item.ParameterId == 256 || item.ParameterId == 36 || item.ParameterId == 258 || item.ParameterId == 69) {
          if (item.structureType == "Apartment" && (item.ParameterId == 256 || item.ParameterId == 36 || item.ParameterId == 69)) {

            return React.createElement(Components[18], {
              id: item.ParameterId,
              name: item.ParameterName,
              IsManual: item.IsManual,
              setData: setData,
              data: data,
              value: useVals ? item.value : null,
              structureType: item.structureType || null,
              key: (item.structureType || " sds ") + item.ParameterId,
              wholeEl: item,
              ischecked: item.ischecked,
              isSite: 0,
              object: object
            });
          }
          else {
            return React.createElement(Components[18], {
              id: item.ParameterId,
              name: item.ParameterName,
              IsManual: item.IsManual,
              setData: setData,
              data: data,
              value: useVals ? item.value : null,
              structureType: item.structureType || null,
              key: (item.structureType || " sds ") + item.ParameterId,
              wholeEl: item,
              ischecked: item.ischecked,
              isSite: 1,
              object: object
            });
          }
        }

        else if (item.ParameterId == 76 || item.ParameterId == 72 || item.ParameterId == 73
          || item.ParameterId == 74 || item.ParameterId == 131 || item.ParameterId == 132
          || item.ParameterId == 192 || item.ParameterId == 191 || item.ParameterId == 78
          || item.ParameterId == 193 || item.ParameterId == 152 || item.ParameterId == 194) {
          return React.createElement(Components[18], {
            id: item.ParameterId,
            name: item.ParameterName,
            IsManual: item.IsManual,
            setData: setData,
            data: data,
            value: useVals ? item.value : null,
            structureType: item.structureType || null,
            key: (item.structureType || " sds ") + item.ParameterId,
            wholeEl: item,
            ischecked: item.ischecked,
            isSite: 1,
            object: object
          });
        }
        else {
          return React.createElement(
            () => <div></div>,
            { key: item._uid }
          );
        }
      }

    }
    if (item.Phase === "Building Cost Breakdown") {


      return React.createElement(Components[16], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: item.ischecked
      });

    }

    if (item.Phase === "Sales Cost Breakdown") {


      return React.createElement(Components[18], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: item.ischecked,
        isSite: 0,
        object: object
      });

    }
    if (item.Phase === "Land Analysis") {


      return React.createElement(Components[17], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: item.ischecked
      });

    }
    if (item.Phase === "Proforma Breakdown") {

      if (IsSite == 9) {
        return React.createElement(Components[21], {
          id: item.ParameterId,
          name: item.ParameterName,
          IsManual: item.IsManual,
          setData: setData,
          data: data,
          value: useVals ? item.value : null,
          structureType: item.structureType || null,
          key: (item.structureType || " sds ") + item.ParameterId,
          wholeEl: item,
          ischecked: item.ischecked
        });

      } else {
        return React.createElement(Components[19], {
          id: item.ParameterId,
          name: item.ParameterName,
          IsManual: item.IsManual,
          setData: setData,
          data: data,
          value: useVals ? item.value : null,
          structureType: item.structureType || null,
          key: (item.structureType || " sds ") + item.ParameterId,
          wholeEl: item,
          ischecked: item.ischecked
        });
      }


    }
    if (item.ParameterId === 3) {
      return React.createElement(Components[7], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }

    if (item.ParameterId === 5 || item.ParameterId === 10 || item.ParameterId === 9) {
      return React.createElement(Components[13], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
    if (item.ParameterId === 6 || item.ParameterId === 7 || item.ParameterId === 29) {
      return React.createElement(Components[14], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
    if (item.ParameterId == 45 || item.ParameterId == 47 || item.ParameterId == 46 || item.ParameterId == 148 || item.ParameterId == 150) {
      return React.createElement(Components[10], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
    if (item.ParameterId == 181) {
      return React.createElement(Components[12], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
    if (item.ParameterId === 189 || item.ParameterId === 190) {
      return React.createElement(Components[8], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
    if (item.ParameterId === 181) {
      return React.createElement(Components[9], {
        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
    if (item.Phase === "Financing") {

      if (IsSite == 0) {

        if (item.ParameterId == 56 || item.ParameterId == 176 || item.ParameterId == 226 || item.ParameterId == 263 || item.ParameterId == 266 || item.ParameterId == 179
          || item.ParameterId == 269 || item.ParameterId == 57 || item.ParameterId == 264 || item.ParameterId == 81 || item.ParameterId == 58 || item.ParameterId == 271) {
          return React.createElement(Components[20], {
            id: item.ParameterId,
            name: item.ParameterName,
            IsManual: item.IsManual,
            setData: setData,
            data: data,
            value: useVals ? item.value : null,
            structureType: item.structureType || null,
            key: (item.structureType || " sds ") + item.ParameterId,
            wholeEl: item,
            ischecked: item.ischecked
          });
        }
      }

      if (IsSite == 1) {

        if (item.ParameterId == 61 || item.ParameterId == 178 || item.ParameterId == 270 || item.ParameterId == 267
          || item.ParameterId == 268 || item.ParameterId == 59 || item.ParameterId == 212 || item.ParameterId == 60
          || item.ParameterId == 213 || item.ParameterId == 211 || item.ParameterId == 62 || item.ParameterId == 272 || item.ParameterId == 274 || item.ParameterId == 275 || item.ParameterId == 4227) {
          return React.createElement(Components[20], {
            id: item.ParameterId,
            name: item.ParameterName,
            IsManual: item.IsManual,
            setData: setData,
            data: data,
            value: useVals ? item.value : null,
            structureType: item.structureType || null,
            key: (item.structureType || " sds ") + item.ParameterId,
            wholeEl: item,
            ischecked: item.ischecked
          });
        }
      }
      if (IsSite == 2) {

        if (item.ParameterId == 64 || item.ParameterId == 65 || item.ParameterId == 265 || item.ParameterId == 273 || item.ParameterId == 276 || item.ParameterId == 277) {
          return React.createElement(Components[20], {
            id: item.ParameterId,
            name: item.ParameterName,
            IsManual: item.IsManual,
            setData: setData,
            data: data,
            value: useVals ? item.value : null,
            structureType: item.structureType || null,
            key: (item.structureType || " sds ") + item.ParameterId,
            wholeEl: item,
            ischecked: item.ischecked
          });
        }
      }
      if (IsSite == 3) {

        if (item.ParameterId == 66) {
          return React.createElement(Components[20], {
            id: item.ParameterId,
            name: item.ParameterName,
            IsManual: item.IsManual,
            setData: setData,
            data: data,
            value: useVals ? item.value : null,
            structureType: item.structureType || null,
            key: (item.structureType || " sds ") + item.ParameterId,
            wholeEl: item,
            ischecked: item.ischecked
          });
        }
      }
      else {
        return React.createElement(
          () => <div></div>,
          { key: item._uid }
        );
      }
    }
    else {

      return React.createElement(Components[item.ParameterTypeId], {

        id: item.ParameterId,
        name: item.ParameterName,
        IsManual: item.IsManual,
        setData: setData,
        data: data,
        value: useVals ? item.value : null,
        structureType: item.structureType || null,
        key: (item.structureType || " sds ") + item.ParameterId,
        wholeEl: item,
        ischecked: setData.ischecked
      });
    }
  }
  return React.createElement(
    () => <div></div>,
    { key: item._uid }
  );
};
